/**
 * Felles utregning for produksjonens sluttidspunkt, brukt av `NyProduksjonDialog` og
 * `ProductionHeaderTailwind`. Sluttid oppgis som klokkeslett (HH:mm) uten dato; er den
 * lik eller tidligere enn starttidens klokkeslett, tolkes den som påfølgende dag
 * (f.eks. produksjon fra 23:00 til 01:00). Se `Docs/Produksjons_bemanning.md`.
 */

/**
 * Er sluttidens klokkeslett (HH:mm) på dagen etter starttidens klokkeslett (HH:mm)?
 */
export function erSluttTidNesteDag(tid: string, sluttTid: string): boolean {
  return Boolean(tid && sluttTid && sluttTid <= tid);
}

/**
 * Regner ut sluttidspunktet som en `Date`, gitt startdato (`YYYY-MM-DD`), starttidens
 * klokkeslett (`HH:mm`) og sluttidens klokkeslett (`HH:mm`). Faller sluttiden på dagen
 * etter (se `erSluttTidNesteDag`), legges én dag til startdatoen.
 */
export function beregnSluttDato(dato: string, tid: string, sluttTid: string): Date {
  const sluttDato = new Date(`${dato}T${sluttTid}`);
  if (erSluttTidNesteDag(tid, sluttTid)) {
    sluttDato.setDate(sluttDato.getDate() + 1);
  }
  return sluttDato;
}
